import { render } from "./comp.competence.vue?vue&type=template&id=f0a54d42"
import script from "./comp.competence.vue?vue&type=script&lang=js"
export * from "./comp.competence.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__